import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

const STORAGE_KEY = 'theme';

const systemTheme = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';

export const ThemeProvider = ({ children }) => {
  // Пока пользователь не выбрал тему сам, идем за настройкой системы
  const [theme, setTheme] = useState(() => localStorage.getItem(STORAGE_KEY) || systemTheme());

  // Все цвета живут в CSS-переменных, переключение сводится к атрибуту на <html>
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.style.colorScheme = theme;
  }, [theme]);

  // Ручной выбор запоминаем, иначе продолжаем следовать системе
  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return undefined;
    if (typeof window.matchMedia !== 'function') return undefined;

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (event) => setTheme(event.matches ? 'dark' : 'light');

    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, []);

  const selectTheme = (next) => {
    localStorage.setItem(STORAGE_KEY, next);
    setTheme(next);
  };

  const toggleTheme = () => selectTheme(theme === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, setTheme: selectTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
